/** Billing source written to `user_preferences.metadata.membership_source`. */
import type { UserPreferenceMetadata } from './userPreferences';

export type MembershipSource = 'apple' | 'web' | 'unknown';

const APPLE_MARKERS = ['apple', 'iap', 'app_store', 'appstore', 'itunes'];
const WEB_MARKERS = ['stripe', 'paypal', 'woo', 'web', 'card', 'bacs', 'cheque', 'manual'];

export function readMembershipSource(
  metadata: UserPreferenceMetadata | null | undefined,
): MembershipSource {
  const raw = metadata?.membership_source;
  if (typeof raw !== 'string') return 'unknown';
  const value = raw.toLowerCase();
  if (APPLE_MARKERS.some((m) => value.includes(m))) return 'apple';
  if (WEB_MARKERS.some((m) => value.includes(m))) return 'web';
  return 'unknown';
}
